import IRepresentativeRepository from 'domain/interfaces/repositories/IRepresentativeRepository'
import {
  CreateRepresentativeCommandRequest,
  CreateRepresentativeCommandResponse,
  ReadInstitutionsByRepresentativeQueryResponse,
  ReadRepresentativeAndStudentsQueryRequest,
  ReadRepresentativeAndStudentsQueryResponse,
  UpdateRepresentativeCommandRequest,
  UpdateRepresentativeCommandResponse,
  UpdateRoleRepresentativeCommandRequest,
  UpdateRoleRepresentativeCommandResponse,
} from 'domain/entities/representative'
import { Query } from 'domain/models/query'
import { sendRequest } from 'infraestructure/dataSources/http/axios'
import { getQueryString } from 'infraestructure/utils/format'
import { AsyncApiResponse } from 'domain/models/apiResponse'
import { GET_INSTITUTIONS_BY_REPRESENTATIVE_ENDPOINT } from './endpoints.routes'

export default class RepresentativeRepository implements IRepresentativeRepository {
  async create(
    data: CreateRepresentativeCommandRequest,
  ): AsyncApiResponse<CreateRepresentativeCommandResponse> {
    const request = {
      post: {
        path: `${process.env.REACT_APP_CORE_API_HOST}/users/manager/create`,
        body: data,
      },
    }
    return await sendRequest<CreateRepresentativeCommandResponse>(request)
  }

  async update(
    representativeId: string,
    data: UpdateRepresentativeCommandRequest,
  ): AsyncApiResponse<UpdateRepresentativeCommandResponse> {
    const request = {
      post: {
        path: `${process.env.REACT_APP_CORE_API_HOST}/representatives/${representativeId}/update`,
        body: data,
      },
    }
    return await sendRequest<UpdateRepresentativeCommandResponse>(request)
  }

  async updateRole(
    promotionId: string,
    representativeId: string,
    data: UpdateRoleRepresentativeCommandRequest,
  ): AsyncApiResponse<UpdateRoleRepresentativeCommandResponse> {
    const request = {
      post: {
        path: `${process.env.REACT_APP_CORE_API_HOST}/${promotionId}/representatives/${representativeId}/update-role`,
        body: data,
      },
    }
    return await sendRequest<UpdateRoleRepresentativeCommandResponse>(request)
  }

  async getInstitutionsByRepresentative(
    query: Query,
  ): AsyncApiResponse<ReadInstitutionsByRepresentativeQueryResponse> {
    const request = {
      get: {
        path: `${GET_INSTITUTIONS_BY_REPRESENTATIVE_ENDPOINT}${
          query ? `?orders=createAt__DESC&${getQueryString(query)}` : `?orders=createAt__DESC&`
        }`,
      },
    }
    return await sendRequest<ReadInstitutionsByRepresentativeQueryResponse>(request)
  }

  async getRepresentativeAndStudentsById(
    params: ReadRepresentativeAndStudentsQueryRequest,
  ): AsyncApiResponse<ReadRepresentativeAndStudentsQueryResponse> {
    const request = {
      get: {
        path: `${process.env.REACT_APP_CORE_API_HOST}/${params.promotionId}/representatives/${params.representativeId}`,
      },
    }
    return await sendRequest<ReadRepresentativeAndStudentsQueryResponse>(request)
  }
}
